import React from 'react'
import { ValueInput } from './styles'

export const SpendInputSkeleton = props => (
  <ValueInput variant="outlined" disabled {...props} />
)

export default SpendInputSkeleton
